import React from 'react';
import classes from "./activities.module.css";
import Title from '../../containers/title/title';
import { getImageUrl } from '../../../utils/imageUrl';
const Activities = (props) => {
    return (
        <div className={classes.Container}>
            <Title title={props.title} camp={props.camp} />
            <div>
                <p>{parseInt(localStorage.getItem('language')) === 1 
                        ? "Get ready to have an extraordinary experience with a wide variety of activities" 
                        :  "استعد لتجربة غير عادية مع مجموعة واسعة من الأنشطة"}</p>
                <div className={classes.Activities}>{props.activities?.map((activity) =>
                    <div className={classes.Activity} key={activity.id}>
                        <div className={classes.ImgContainer}><img src={getImageUrl(activity.image)} alt={activity.name} /></div>
                        <div className={[classes.ActivityName, props.camp === 'winter' && classes.WinterActivityName
                            , props.camp === 'football' && classes.FootballActivityName
                        ].join(" ")}>
                            <h4>{activity.name}</h4>
                        </div>
                    </div>
                )}</div>
            </div>
        </div>
    )
}
export default Activities;